import { useEffect, useState } from "react";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import { Button, Col, Divider, Modal, Row, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";
import DataTable from "../components/DataTable";

import { useLocation, useNavigate } from "react-router-dom";
import RentRegisterReview from "./RentRegisterReview";

const REVIEW_BOARD_IDS = "1-2";

function RentReviewList() {
    const [boardArticles, setBoardArticles] = useState<Types.Page<Types.BoardArticleDto>>(Common.EMPTY_PAGE);
    const [currentBoardArticle, setCurrentBoardArticle] = useState<Types.BoardArticleDto>();

    const [editMode, setEditMode] = useState<string>("none");
    const [openDeleteBoardArticle, setOpenDeleteBoardArticle] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setCurrentBoardArticle(undefined);
        requestGetBoardArticles();
    }, [location]);

    const requestAxiosGetBoardArticles = async () => {
        const pageNumber = +(new URLSearchParams(location.search).get("page") ?? "1");
        const response = await utilAxiosWithAuth().get(Request.BOARD_URL + "/" + REVIEW_BOARD_IDS, {
            params: { page: pageNumber - 1, size: Common.PAGE_SIZE },
        });
        return response.data;
    };

    const {
        loading: loadingGetBoardArticles,
        error: errorGetBoardArticles,
        data: resultGetBoardArticles,
        execute: requestGetBoardArticles,
    } = useAsyncAxios(requestAxiosGetBoardArticles);

    useEffect(() => {
        if (resultGetBoardArticles === null) return;
        console.log("resultGetBoardArticles", resultGetBoardArticles);
        setBoardArticles(resultGetBoardArticles.boardArticles);
    }, [resultGetBoardArticles]);

    useEffect(() => {
        if (errorGetBoardArticles === null) return;
        console.log("errorGetBoardArticles", errorGetBoardArticles);
    }, [errorGetBoardArticles]);

    const onChange = (pagination: any) => {
        navigate(`?page=${pagination.current}`);
    };

    const columns: ColumnsType<Types.BoardArticleDto> = [
        {
            align: "center",
            title: "번호",
            dataIndex: "num",
            key: "num",
            render: (item, record, index) => {
                const pageable = boardArticles.pageable;
                return boardArticles.totalElements - pageable.pageSize * pageable.pageNumber - index;
            },
        },
        {
            align: "center",
            title: "차량",
            dataIndex: "extraInfo1",
            key: "extraInfo1",
        },
        {
            align: "left",
            title: "제목",
            dataIndex: "title",
            key: "title",
            //width: "40%",
        },
        {
            align: "center",
            title: "미디어채널",
            dataIndex: "extraInfo2",
            key: "extraInfo2",
        },
        {
            align: "center",
            title: "글쓴이",
            dataIndex: "extraInfo3", //["user", "name"],
            key: "extraInfo3",
        },
        {
            align: "center",
            title: "카테고리",
            dataIndex: ["board", "boardName"],
            key: "boardName",
        },
        {
            align: "center",
            title: "이달베",
            dataIndex: "fixed",
            key: "fixed",
            render: (_, { fixed }) => {
                return <span>{fixed === true ? "○" : "✕"}</span>;
            },
        },
        {
            align: "center",
            title: "조회수",
            dataIndex: "hits",
            key: "hits",
        },
        {
            align: "center",
            title: "등록일",
            dataIndex: "registeredDate",
            key: "registeredDate",
        },
        {
            align: "center",
            title: " ",
            dataIndex: "action",
            key: "action",
            render: (_, row) => {
                return (
                    <>
                        <Button
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                setCurrentBoardArticle(row);
                                setEditMode("update");
                            }}
                        >
                            {String.update}
                        </Button>{" "}
                        <Button
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                setCurrentBoardArticle(row);
                                setOpenDeleteBoardArticle(true);
                            }}
                        >
                            {String.remove}
                        </Button>
                    </>
                );
            },
        },
    ];

    const requestAxiosRemoveBoardArticle = async (boardArticle: Types.BoardArticleDto) => {
        const response = await utilAxiosWithAuth().delete(Request.BOARD_URL + "/" + boardArticle.board.boardId + "/" + boardArticle.boardArticleId);
        return response.data;
    };

    const {
        loading: loadingRemoveBoardArticle,
        error: errorRemoveBoardArticle,
        data: resultRemoveBoardArticle,
        execute: requestRemoveBoardArticle,
    } = useAsyncAxios(requestAxiosRemoveBoardArticle);

    useEffect(() => {
        if (resultRemoveBoardArticle === null) return;
        console.log("resultRemoveBoardArticle", resultRemoveBoardArticle);

        setEditMode("none");
        setCurrentBoardArticle(undefined);
        requestGetBoardArticles();
    }, [resultRemoveBoardArticle]);

    useEffect(() => {
        if (errorRemoveBoardArticle === null) return;
        console.log("errorRemoveBoardArticle", errorRemoveBoardArticle);
    }, [errorRemoveBoardArticle]);

    const handleRemoveBoardArticleOk = () => {
        setOpenDeleteBoardArticle(false);
        requestRemoveBoardArticle(currentBoardArticle);
    };

    const handleRemoveBoardArticleCancel = () => {
        setEditMode("none");
        setOpenDeleteBoardArticle(false);
        setCurrentBoardArticle(undefined);
    };

    const onRegisterBoardArticle = () => {
        setEditMode("none");
        setCurrentBoardArticle(undefined);
        requestGetBoardArticles();
    };

    return (
        <>
            <Row justify={"space-between"}>
                <Col span={6}>
                    <Divider orientation="left">
                        <span>베스트리뷰/전체리뷰</span>
                    </Divider>
                </Col>
                <Space>
                    <Button
                        onClick={() => {
                            setCurrentBoardArticle(undefined);
                            setEditMode("add");
                        }}
                    >
                        {String.userAdd}
                    </Button>
                </Space>
            </Row>
            <DataTable
                loading={loadingGetBoardArticles}
                hasScroll={false}
                columns={columns}
                rowKey="boardArticleId"
                dataSource={boardArticles.content}
                tableSize={Common.PAGE_SIZE}
                pageNumber={boardArticles.pageable.pageNumber + 1}
                total={boardArticles.totalElements}
                onChange={onChange}
            />

            {editMode === "add" && <RentRegisterReview editMode={editMode} onRegisterBoardArticle={onRegisterBoardArticle} />}

            {editMode !== "add" && currentBoardArticle !== undefined && (
                <RentRegisterReview
                    editMode={editMode}
                    boardArticle={currentBoardArticle}
                    onRegisterBoardArticle={onRegisterBoardArticle}
                />
            )}

            {openDeleteBoardArticle && (
                <Modal open={openDeleteBoardArticle} onOk={handleRemoveBoardArticleOk} onCancel={handleRemoveBoardArticleCancel}>
                    리뷰를 삭제하시겠습니까?
                </Modal>
            )}
        </>
    );
}

export default RentReviewList;
